import { render, staticRenderFns } from "./GridLegalDetails.vue?vue&type=template&id=e46e1dfa&scoped=true&"
import script from "./GridLegalDetails.vue?vue&type=script&lang=js&"
export * from "./GridLegalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46e1dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e46e1dfa')) {
      api.createRecord('e46e1dfa', component.options)
    } else {
      api.reload('e46e1dfa', component.options)
    }
    module.hot.accept("./GridLegalDetails.vue?vue&type=template&id=e46e1dfa&scoped=true&", function () {
      api.rerender('e46e1dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/legal-details/grid/GridLegalDetails.vue"
export default component.exports